import React from 'react'

function Icon({
  width = '20',
  height = '20'
}) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none">
  <circle cx="12" cy="12" r="10" stroke="#3B82F6" stroke-width="2"/>
  <path d="M12 7v5l3 3" stroke="#3B82F6" stroke-width="2" stroke-linecap="round"/>
</svg>
  )
}

export default Icon